import React, { useState, useEffect } from "react";
import { Typography, Paper } from "@mui/material";
import NotificationForm from "./NotificationForm";
import NotificationTable from "./NotificationTable";
import { BglLoading } from "components/loading/BglLoading"; // Loading component
import { useGlobalConfig } from "context/GlobalContext";

export const NotificationView = () => {
  const { rc } = useGlobalConfig();
  const [pilotId, setPilotId] = useState();
  const [startTime, setStartTime] = useState(
    Math.floor((Date.now() - 2 * 24 * 60 * 60 * 1000))
  ); // 2 days ago in epoch (seconds)
  const [endTime, setEndTime] = useState(Math.floor(Date.now())); // current time in epoch (seconds)

  const [eventName, setEventName] = useState("");
  const [customEventName, setCustomEventName] = useState("");
  const [notifications, setNotifications] = useState(undefined);
  const [notificationError, setNotificationError] = useState("");
  const [selectedNotifications, setSelectedNotifications] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [notificationStatus, setNotificationStatus] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalNotifications, setTotalNotifications] = useState(0);
  const [notificationsPerPage, setNotificationsPerPage] = useState(100);

  const handleFetchNotifications = async () => {
    if(!pilotId || !notificationStatus || (!customEventName && !eventName) ) {
      setNotificationError('Please Enter all the required fields'); 
      return
    };
    setIsLoading(true);
    const finalUrl = `/2.1/utility_notifications/${pilotId}/fetch-notifications?startTime=${Math.floor(startTime/1000)}&endTime=${Math.floor(endTime/1000)}&offset=${
      (currentPage - 1)*notificationsPerPage
    }&limit=${notificationsPerPage}&eventName=${
      customEventName || eventName
    }&notificationStatus=${notificationStatus}`;

    let response, data;
    try {
      response = await rc.apiClient.get(finalUrl);
      data = response?.data
    }
    catch(err){
      setIsLoading(false);
      setNotifications([]);
      setTotalNotifications(0);
      setNotificationError("There is some issue in api endpoint. Note:- Do not include https in the endpoint");
      return;
    }
    
    if (response.error) {
      setIsLoading(false);
      setNotifications([]);
      setTotalNotifications(0);
      setNotificationError(response.error);
      return;
    }
    setNotificationError(undefined);
    setNotifications(data); // Assuming the response contains a notifications array
    setTotalNotifications(data?.length); // Assuming the response contains the total count of notifications
    setIsLoading(false);
  };

  useEffect(() => {
    console.log("currentPage", currentPage)
    handleFetchNotifications();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage,notificationsPerPage]);


  return (
    <div>
      <Typography gutterBottom>
        Email Preview Form{" "}
      </Typography>
      <NotificationForm
        pilotId={pilotId}
        setPilotId={setPilotId}
        startTime={startTime}
        setStartTime={setStartTime}
        endTime={endTime}
        setEndTime={setEndTime}
        eventName={eventName}
        setEventName={setEventName}
        customEventName={customEventName}
        setCustomEventName={setCustomEventName}
        onFetchNotifications={()=>{ setCurrentPage(1);handleFetchNotifications();}}
        notificationStatus={notificationStatus}
        setNotificationStatus={setNotificationStatus}
      />
      {isLoading ? (
        <BglLoading />
      ) : notificationError ? (
        <Typography variant="body1" color="error">
          {notificationError?.message || notificationError}
        </Typography>
      ) : (
        <Paper style={{ marginTop: "16px", padding: "16px" }}>
          {notifications && (
            <NotificationTable
              notifications={notifications}
              selectedNotifications={selectedNotifications}
              setSelectedNotifications={setSelectedNotifications}
              currentPage={currentPage}
              totalNotifications={totalNotifications}
              notificationsPerPage={notificationsPerPage}
              onPageChange={(pageChange)=> {setCurrentPage(pageChange)}}
              pilotId={pilotId}
              handleFetchNotifications={handleFetchNotifications}
              setNotificationsPerPage={setNotificationsPerPage}
              setCurrentPage={setCurrentPage}
            />
          )}
        </Paper>
      )}
    </div>
  );
};

export default NotificationView;
